<div
	*ngIf="folder && folder?.moduleLinkedType === typeModule.SHEETS"
	class="background"
	style="width: 100%; background: transparent"
>
	<div [ngClass]="'event-users-container'">
		<ion-searchbar
			*ngIf="sheetModule && sheetModule.options && sheetModule.options.showSearchIcon"
			[(ngModel)]="searchValue"
			class="event-users-searchbar"
			searchIcon="assets/icon/Search.svg"
			mode="md"
			[style.--background]="'rgb(234, 239, 242)'"
			[style.margin-left]="'auto'"
			placeholder="{{ 'texts.search_plc' | translate }}"
			(ionClear)="resetFilter()"
			(keyup)="searchBar($event)"
		>
		</ion-searchbar>
		<ng-container *ngIf="!loader">
			<ng-container *ngIf="filteredSheets.length > 0; else emptyContent">
				<div #contentContainer class="content-container" [ngClass]="'pb-0'">
					<!-- <ion-content class="content-container" id="content-container" style="--background: transparent;"> -->
					<cdk-virtual-scroll-viewport
						#virtualScrollSheets
						(scrolledIndexChange)="scrolledIndexChanged($event, contentContainer)"
						style="height: 100%; width: 100%"
						[itemSize]="itemSize"
						[minBufferPx]="height"
						[maxBufferPx]="height"
					>
						<div
							id="main-list"
							style="height: 100%"
							[style.padding-top]="!sheetModule.options.showSearchIcon ? '25px' : '0'"
							[style.margin-left]="'auto'"
						>
							<!-- Normal list -->
							<ng-container *ngIf="!sheetModule.options.showListInTwoBloc">
								<ng-container *cdkVirtualFor="let sheet of filteredSheets">
									<div
										*ngIf="groupedLetters[sheet.uid]"
										class="header-divider"
										[hidden]="!sheetModule.options.showLetters"
										style="height: 50px"
									>
										<div class="letter" [style.color]="event.styling.titleColor">
											{{ groupedLetters[sheet.uid] }}
										</div>
										<div class="bar" [style.background-color]="event.styling.titleColor"></div>
									</div>

									<ion-item lines="none" (click)="navigateTo(sheet)" class="item-list">
										<ion-avatar
											slot="start"
											[ngStyle]="{ padding: sheet?.photoUrl === '' ? '20px 0' : '' }"
										>
											<img
												class="picture"
												[src]="sheet?.photoUrl"
												*ngIf="sheet.photoUrl !== ''"
											/>
											<ion-img
												class="cus-picture"
												*ngIf="sheet?.photoUrl === ''"
												src="assets/icon/User2.svg"
											>
											</ion-img>
										</ion-avatar>

										<ion-label style="height: auto">
											<h2 class="line-clamp-2" [style.color]="event.styling.titleColor">
												{{ sheet?.name }}
											</h2>
											<div
												class="margin-padding-0"
												*ngFor="let customField of getSheetTags(sheet); let count = count"
											>
												<h5
													class="ellipsis-100 custom-fields-event-users-module-item-tags"
													[style.color]="event.styling.contentTextColor"
													[style.fontSize]="count === 3 ? 'O.8rem' : '0.9rem'"
												>
													{{
														customField.field.text?.trim() ||
															customField.field.multiLanguageText?.[
																currentLanguage
															]?.trim() ||
															customField.field.numeric?.toString()
													}}
												</h5>
											</div>
										</ion-label>

										<!-- Download contact -->
										<!-- <ion-icon slot="end" name="bookmark_remove" fill="{{ event.styling.contentTextColor }}"
                      style="position: relative; top: -1px" [style.color]="event.styling.contentTextColor"
                      src="assets/icon/download_contact_2.svg"
                      *ngIf="favoriteModule?.options?.enableFavoriteVcardsDownload" (click)="
												SFavorite.downloadVcard(event, module, $any(sheet), customFields, $event)
											">
                    </ion-icon> -->

										<!-- remove bookmark icon-->
										<ion-icon
											slot="end"
											name="bookmark_remove"
											fill="{{ event.styling.contentTextColor }}"
											[style.color]="event.styling.contentTextColor"
											src="assets/icon/bookmark_remove.svg"
											*ngIf="
												favoriteModule &&
												favoriteModule.options &&
												(!favoriteModule.options.hideFavoriteMenuIcon ||
													!favoriteModule.options.hideFavoriteHeaderIcon)
											"
											(click)="removeFromFavorite(sheet.uid, $event)"
										>
										</ion-icon>
									</ion-item>
								</ng-container>
							</ng-container>

							<!-- Two blocs list -->
							<ion-list *ngIf="sheetModule.options.showListInTwoBloc">
								<div class="f-row-c-c" *cdkVirtualFor="let sheets of filteredSheetsInTwo">
									<ng-container *ngFor="let sheet of sheets">
										<ion-card
											[style.min-width]="isMobile ? '45vw' : '250px'"
											[style.width]="isMobile ? '45vw' : '250px'"
											style="height: 250px"
										>
											<div
												*ngIf="sheet?.photoUrl"
												style="
													width: 100%;
													display: flex;
													flex-direction: row;
													align-items: center;
													justify-content: center;
													padding: 10px;
												"
											>
												<ion-avatar
													[ngStyle]="{ padding: sheet?.photoUrl === '' ? '20px 0' : '' }"
												>
													<img
														class="picture"
														[src]="sheet?.photoUrl"
														*ngIf="sheet.photoUrl !== ''"
													/>
													<ion-img
														class="cus-picture"
														*ngIf="sheet?.photoUrl === ''"
														src="assets/icon/User2.svg"
													>
													</ion-img>
												</ion-avatar>
											</div>
											<ion-card-header>
												<ion-card-title
													class="line-clamp-2"
													[style.color]="event.styling.titleColor"
													>{{ sheet?.name }}
												</ion-card-title>
											</ion-card-header>

											<ion-card-content>
												<div
													class="margin-padding-0"
													*ngFor="let customField of getSheetTags(sheet); let count = count"
												>
													<h5
														class="ellipsis-100 custom-fields-event-users-module-item-tags"
														[style.color]="event.styling.contentTextColor"
														[style.fontSize]="count === 3 ? 'O.8rem' : '0.9rem'"
													>
														{{
															customField.field.text?.trim() ||
																customField.field.multiLanguageText?.[
																	currentLanguage
																]?.trim() ||
																customField.field.numeric?.toString()
														}}
													</h5>
												</div>
											</ion-card-content>
										</ion-card>
									</ng-container>
								</div>
							</ion-list>
						</div>
					</cdk-virtual-scroll-viewport>
					<div class="container-no-result" *ngIf="showNoResultImage">
						<ion-icon
							src="assets/images/emptycontent/AUCUNRESULTAT.svg"
							[style.color]="
								event.styling.menuColor.includes('linear')
									? event.styling.menuColor.split(',')[1]
									: event.styling.menuColor
							"
						>
						</ion-icon>
						<div class="text-empty-content" [style.color]="event.styling.contentTextColor">
							<span class="title"> {{ "texts.no_result_title" | translate }}</span>
							<span>{{ "texts.no_result_text" | translate }}</span>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #emptyContent>
				<div class="container">
					<span class="wait-content" [style.color]="event.styling.titleColor">{{
						(dontBelongAnyGroups
							? "texts.not_belonging_to_any_group"
							: searchValue
								? "texts.no_result_title"
								: "texts.waiting_for_content"
						) | translate
					}}</span>
					<ion-icon
						[src]="
							!searchValue
								? 'assets/images/emptycontent/PARTICIPANTS.svg'
								: 'assets/images/emptycontent/AUCUNRESULTAT.svg'
						"
						[style.color]="
							event.styling.menuColor.includes('linear')
								? event.styling.menuColor.split(',')[1]
								: event.styling.menuColor
						"
					>
					</ion-icon>
					<div *ngIf="!searchValue" class="text-empty-content" [style.color]="event.styling.contentTextColor">
						<span class="title"> {{ "event_users.empty_content_title" | translate }}</span>
						<span>{{ "event_users.empty_content_text" | translate }}</span>
					</div>
				</div>
			</ng-template>
		</ng-container>

		<!-- await loading attendees list -->
		<div *ngIf="loader" class="loader-block">
			<ion-item-divider>
				<ion-skeleton-text animated style="width: 10%"></ion-skeleton-text>
			</ion-item-divider>
			<ion-item lines="none" *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
				<ion-avatar slot="start">
					<img src="../../../assets/images/grey.jpg" />
				</ion-avatar>
				<ion-label>
					<h3>
						<ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
					</h3>
					<h3>
						<ion-skeleton-text animated style="width: 45%"></ion-skeleton-text>
					</h3>
					<h3>
						<ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
					</h3>
				</ion-label>
			</ion-item>
		</div>
	</div>
</div>
